import { createAsyncState } from '../hooks';
export var useAuthorizationAsync = createAsyncState('authorization');
export var useAuthorizationState = function () { return useAuthorizationAsync()[0]; };
